customElements.define(
  'product-bundle',
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.trigger = this.querySelector('[data-bundle-trigger]');
      this.panel = this.querySelector('[data-bundle-panel]');
      this.input = this.querySelector('[data-note-input]');
      this.trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggleBundleCard();
      });

    }

    toggleBundleCard() {
      if (this.classList.contains('active')) {
        this.classList.remove('active');
        this.panel.style.display = "none";
      } else {
        this.classList.add('active');
        this.panel.style.display = "block";
      }
    }

  },
);
